import React, { useState } from "react";
import { Button, Modal, Checkbox } from "antd";
import noProfile from '../../images/noProfile.jpg'



const ViewSubContracter = ({
  showSubContracter,
  setShowSubContracter,
  selectedSubContracter,
}) => {
  const [open, setOpen] = useState(showSubContracter);
  const [loading, setLoading] = useState(false);
  const [isHstApplied, setIsHstApplied] = useState(selectedSubContracter.applyHst);


  const closeViewModal = () => {
    setOpen(false);
    setShowSubContracter(false);
  };


  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white  rounded-lg shadow-lg w-[900px] h-[600px] overflow-y-auto scrollbar-hidden">
          <h3 className="text-xl font-bold mb-2 text-center bg-blue-950 py-2 text-white">View Sub Contractor</h3>
          <form className="p-8">
            <h1 className="bg-gray-400 border border-gray-900 flex justify-center text-xl font-semibold mb-2 py-2">Personal Details</h1>
            <div className="flex gap-2 ">
              <div className='w-full'>
                <label className="block mb-1">First Name:</label>
                  <input
                    type="text"
                    name="name"
                    className="border border-gray-800 p-2 w-full"

                    value={selectedSubContracter.firstName}
                    disabled
                  />

              </div>

              <div className='w-full'>
                <label className="block mb-1">Last Name:</label>
                <input
                  type="text"
                  name="lastName"
                  className="border border-gray-800 p-2 w-full"

                  value={selectedSubContracter.lastName}
                  disabled
                />

              </div>
            </div>

            <div className="flex gap-2 mt-2">
            <div className='w-full'>
              <label className="block mb-1 mt-2">Email:</label>
              <input
                type="email"
                name="email"
                className="border border-gray-800 p-2 w-full"

                value={selectedSubContracter.email}
                disabled
              />
              </div>

              <div className='w-full'>
              <label className="block mb-1 mt-2">Status:</label>
              <input
                type="text"
                name="status"
                className="border border-gray-800 p-2 w-full"

                value={selectedSubContracter.active === true ? 'Active' : 'Inactive'}
                disabled
              />
              </div>

            </div>
            <div className="flex gap-2 mt-2">
              <div className='w-full'>
                <label className="block mb-1">Phone:</label>
                <input
                  type="text"
                  name="phone"
                  className="border border-gray-800 p-2 w-full"

                  value={selectedSubContracter.phone}
                  disabled
                />

              </div>

              <div className='w-full'>
                <label className="block mb-1">Emergency Contact:</label>
                <input
                  type="text"
                  name="emergencyContact"
                  className="border border-gray-800 p-2 w-full"

                  value={selectedSubContracter.emergencyPhone}
                  disabledstartData
                />

              </div>
            </div>
            <div className="flex gap-2 mt-2">


              <div className='w-full'>
                <label className="block mb-1">Company Name:</label>
                <input
                  type="text"
                  name="bus"
                  className="border border-gray-800 p-2 w-full"

                  value={selectedSubContracter.companyName}
                  disabled
                />
              </div>

              <div className='w-full'>
                <label className="block mb-1">Profile Image:</label>
                {selectedSubContracter?.profileImage ? <img
                        src={selectedSubContracter?.profileImage}
                        alt="Profile Preview"
                  className="h-20 w-20 object-cover"
                      /> :
                        <img
                          src={noProfile}
                          
                          alt="Profile Preview"
                  className="h-20 w-20 object-cover"
                        />}
               
              </div>
            </div>

            <h1 className="bg-gray-400 border border-gray-900 flex justify-center text-xl font-semibold mt-3 mb-2 py-2">Address Details</h1>

            <div className="flex gap-2 mt-2">
              <div className='w-full'>
                <label className="block mb-1">Street No:</label>
                <input
                  type="text"
                  name="streetno"
                  className="border border-gray-800 p-2 w-full"

                  value={selectedSubContracter.street}
                  disabled
                />
              </div>

              <div className='w-full'>
                <label className="block mb-1">City:</label>
                <input
                  type="text"
                  name="city"
                  className="border border-gray-800 p-2 w-full"

                  value={selectedSubContracter.city}
                  disabled
                />
              </div>

              <div className='w-full'>
                <label className="block mb-1">Prov:</label>
                <input
                  type="text"
                  name="prov"
                  className="border border-gray-800 p-2 w-full"

                  value={selectedSubContracter.prov}
                  disabled
                />
              </div>
            </div>
            <div className="flex gap-2 mt-2">
              <div className='w-full'>
                <label className="block mb-1">Code:</label>
                <input
                  type="text"
                  name="code"
                  className="border border-gray-800 p-2 w-full"

                  value={selectedSubContracter.code}
                  disabled
                />
              </div>
              <div className='w-full'>
                <label className="block mb-1">Home Phone:</label>
                <input
                  type="text"
                  name="homephone"
                  className="border border-gray-800 p-2 w-full"

                  value={selectedSubContracter.homePhone}
                  disabled
                />
              </div>
            </div>
            <h1 className="bg-gray-400 border border-gray-900 flex justify-center text-xl font-semibold mt-4 mb-2 py-2">Other Details</h1>
            <div className="flex gap-2 mt-2">
              <div className='w-full'>
                <label className="block mb-1">Ins. #:</label>
                <input
                  type="text"
                  name="ins"
                  className="border border-gray-800 p-2 w-full"

                  value={selectedSubContracter.ins}
                  disabled
                />
              </div>

              <div className='w-full'>
                <label className="block mb-1">Bus. #:</label>
                <input
                  type="text"
                  name="bus"
                  className="border border-gray-800 p-2 w-full"

                  value={selectedSubContracter.bus}
                  disabled
                />
              </div>

              <div className='w-full'>
                <div className="flex gap-2">
                  <label className="block mb-1">Apply HST #:</label>
                  <Checkbox
                    checked={isHstApplied}
                    disabled
                    style={{
                      color: isHstApplied ? 'blue' : 'black', // Color for the label
                    }}
                  >
                    <span
                      style={{
                        color: isHstApplied ? 'blue' : 'black', // Color for the label
                      }}
                    >
                    </span>
                    <style jsx>{`
        .ant-checkbox-checked .ant-checkbox-inner {
          background-color: blue !important; // Background color when checked
          border-color: blue !important; // Border color when checked
        }
        .ant-checkbox-checked .ant-checkbox-inner::after {
          border-color: white !important; // Check mark color when checked
        }
      `}</style>
                  </Checkbox>
                </div>
                <input
                  type="text"
                  name="hst"
                  className="border border-gray-800 p-2 w-full"

                  value={selectedSubContracter.hst}
                  disabled
                />
              </div>

              <div className='w-full'>
                <label className="block mb-1">HstRate #:</label>
                <input
                  type="text"
                  name="hstrate"
                  className="border border-gray-800 p-2 w-full"

                  value={selectedSubContracter.hstRate}
                  disabled
                />
              </div>


            </div>
            <div className='w-full col-span-3 mt-2'>
              <label className="block mb-1">Comment:</label>
              <textarea
                rows={4}
                name="comment"

                value={selectedSubContracter.comment}
                placeholder="Enter your comments"
                className="border border-gray-800 p-2 w-full"
                disabled
              />
            </div>
            <div className="flex justify-end gap-6 mt-6">
              <button onClick={closeViewModal} className="bg-blue-500 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200">
                Ok
              </button>
              {/* <button type="submit" className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2">
                Create
              </button> */}

            </div>
          </form>
        </div>
      </div>

    </>
  );
};

export default ViewSubContracter;
